import { IParams, IValidation } from './types'

export function initialParams(): IParams {
  return {
    address_country: 'US',
    address_zip: '',
    cvc: '',
    exp: '',
    number: '',
  }
}

export function validate(params: IParams) {
  const hints: IValidation = {}

  if (!params.address_zip) {
    hints.address_zip = 'Please enter a zip code'
  }

  if (!params.cvc) {
    hints.cvc = 'Please enter the CVC'
  }

  if (!params.exp) {
    hints.exp = 'Please enter the expiration date'
  }

  if (!params.number) {
    hints.number = 'Please enter a credit card number'
  }

  if (params.exp && params.exp.length !== 5) {
    hints.exp = 'Invalid expiration'
  }

  if (params.number && params.number.length < 8) {
    hints.number = 'Invalid credit card number'
  }

  if (params.cvc && params.cvc.length !== 3 && params.cvc.length !== 4) {
    hints.cvc = 'Invalid CVC'
  }

  if (params.address_zip && params.address_zip.length !== 5) {
    hints.address_zip = 'Invalid zip code'
  }

  return Object.keys(hints).length ? hints : null
}
